import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { I2gNgTrackingService, ITrackingObject } from 'i2g-ng-tracking';
import { ChangeEmailSuccessBuilder } from './change-email-success.builder';
import { AccountStore } from '../../store/stores';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';

@Component({
  selector: 'app-change-email-success',
  templateUrl: './change-email-success.component.html',
  styleUrls: ['./change-email-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ChangeEmailSuccessBuilder],
})
export class ChangeEmailSuccessComponent implements OnInit, AfterViewInit {
  successIcon: IIcon;
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  loginRoute: IRouter;
  alignmentEnum: typeof AlignmentEnum;

  constructor(
    private _router: Router,
    private _trackingService: I2gNgTrackingService,
    private _changeEmailSuccessBuilder: ChangeEmailSuccessBuilder,
    private _accountStore: AccountStore
  ) {}

  ngOnInit() {
    this.trackingScreenName = TrackingScreenNamesEnum.change_email_success;
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
    this.alignmentEnum = AlignmentEnum;
    this.loginRoute = this._changeEmailSuccessBuilder.buildLoginRoute();

    this.successIcon = {
      name: 'success',
      size: IconSizesEnum.custom,
    };
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }
}
